export const generatedMaterialsProcessEvidenceLedger = {
  "schemaVersion": 1,
  "generatedAt": "2026-06-19T00:00:00.000Z",
  "mode": "deterministic-materials-process-evidence-ledger",
  "operatingRule": "Materials and manufacturing-process claims require source-backed material properties, site/feedstock records, and promoted runtime artifacts before process, throughput, quality, or cost claims can promote.",
  "artifactContract": {
    "id": "artifact-materials-process-v1",
    "name": "Materials/process physics module contract",
    "claimState": "hypothesis",
    "runtimeStatus": "design-contract",
    "nextAction": "Add NIST/Materials Project/Cantera/MOOSE/OpenFOAM artifact adapters.",
    "readinessInputs": {
      "sourceTraceability": 0.5,
      "queryReproducibility": 0.35,
      "unitsCoverage": 0.55,
      "uncertaintyCoverage": 0.45,
      "runtimeGenerated": 0,
      "independentValidation": 0
    }
  },
  "processCount": 3,
  "blockedProcessCount": 3,
  "promotionAllowed": false,
  "evidenceHashes": {
    "modelArtifactBundle": "sha256-f3b0e534f4e7fb6c252f258ea4c741d6ee42b9bafb479bfb6e680c3c2d48a030",
    "sourceRegistry": "sha256-f71caf92b2e76cd344ad65330ce3533cc1f5657002f82b6ff69fa39acdb89780",
    "processDefinitions": "sha256-90b436907aab00da86c5fb226b5635c30bfd21e97bcbfb649346efdc9519b4ad",
    "scenarioDefinitions": "sha256-f067a71064742caa1c8227a624b11859bfea45cbb0bb407dce206c35ff88fb9d"
  },
  "sourceFamilyCoverage": [
    {
      "sourceId": "nist-codata",
      "present": true,
      "recordHash": "fnv1a32-333cff52"
    },
    {
      "sourceId": "nist-chemistry-webbook",
      "present": true,
      "recordHash": "fnv1a32-d9ac987b"
    },
    {
      "sourceId": "materials-project",
      "present": true,
      "recordHash": "fnv1a32-c46b2daa"
    },
    {
      "sourceId": "cantera",
      "present": true,
      "recordHash": "fnv1a32-883bdb34"
    },
    {
      "sourceId": "moose-framework",
      "present": true,
      "recordHash": "fnv1a32-a9482599"
    },
    {
      "sourceId": "openfoam",
      "present": true,
      "recordHash": "fnv1a32-124056ab"
    },
    {
      "sourceId": "pds",
      "present": true,
      "recordHash": "fnv1a32-7c477cc2"
    }
  ],
  "topProcessGaps": [
    {
      "processId": "spf-db",
      "processName": "Superplastic Forming / Diffusion Bonding",
      "evidenceScore": 58,
      "bestScenarioId": "hybrid",
      "blockerCount": 3,
      "nextAction": "thermal cycle energy balance"
    },
    {
      "processId": "vacuum-sheet",
      "processName": "Vacuum Anisotropic Sheet Manufacturing",
      "evidenceScore": 61,
      "bestScenarioId": "hybrid",
      "blockerCount": 3,
      "nextAction": "MOOSE thermo-mechanical forming residual record"
    },
    {
      "processId": "oxygen-isru",
      "processName": "Oxygen Extraction / ISRU",
      "evidenceScore": 64,
      "bestScenarioId": "hybrid",
      "blockerCount": 3,
      "nextAction": "Cantera chemistry/thermodynamics run"
    }
  ],
  "records": [
    {
      "processId": "vacuum-sheet",
      "processName": "Vacuum Anisotropic Sheet Manufacturing",
      "maturity": "Experimental planner concept",
      "uncertainty": "High",
      "evidenceFamily": "vacuum-structural-manufacturing",
      "currentUse": "Use only as a process-fit hypothesis until material property records and thermo-mechanical runtime artifacts are promoted.",
      "flow": [
        "rolled sheet",
        "vacuum handling",
        "controlled forming",
        "NDE",
        "structural panel"
      ],
      "parameters": [
        [
          "Temperature regime",
          "Low/warm controlled; below recrystallization target"
        ],
        [
          "Core value",
          "Preserve directional worked/rolled structure where possible"
        ],
        [
          "Main risk",
          "Tooling, reaction forces, anchoring, NDE at scale"
        ]
      ],
      "sourceRefs": [
        {
          "sourceId": "nist-codata",
          "title": "2022 CODATA Fundamental Physical Constants",
          "trust": "primary",
          "sourceType": "physical-constants",
          "recordHash": "fnv1a32-333cff52",
          "url": "https://physics.nist.gov/cuu/Constants/Table/allascii.txt",
          "queryPolicy": "Constants release and exact constant identifiers required.",
          "uncertaintyMode": "CODATA uncertainty or exact-SI status."
        },
        {
          "sourceId": "materials-project",
          "title": "Materials Project API",
          "trust": "primary",
          "sourceType": "materials-property-api",
          "recordHash": "fnv1a32-c46b2daa",
          "url": "https://docs.materialsproject.org/downloading-data/using-the-api",
          "queryPolicy": "mp-id, fields, API version/client, method metadata, and retrieval hash required.",
          "uncertaintyMode": "DFT/method limitations, provenance, and contributed-data caveats."
        },
        {
          "sourceId": "moose-framework",
          "title": "MOOSE Framework",
          "trust": "primary",
          "sourceType": "multiphysics-framework",
          "recordHash": "fnv1a32-a9482599",
          "url": "https://mooseframework.inl.gov/",
          "queryPolicy": "Input file, application/version, mesh hash, material data, and output hash required.",
          "uncertaintyMode": "Discretization, mesh convergence, solver residuals, and material uncertainty."
        },
        {
          "sourceId": "openfoam",
          "title": "OpenFOAM",
          "trust": "open-source",
          "sourceType": "cfd-toolkit",
          "recordHash": "fnv1a32-124056ab",
          "url": "https://www.openfoam.com/",
          "queryPolicy": "Case directory hash, solver/version, mesh, boundary conditions, and result hash required.",
          "uncertaintyMode": "Mesh convergence, turbulence model, chemistry model, and boundary-condition uncertainty."
        },
        {
          "sourceId": "pds",
          "title": "Planetary Data System",
          "trust": "primary",
          "sourceType": "mission-data-archive",
          "recordHash": "fnv1a32-7c477cc2",
          "url": "https://pds.nasa.gov/datasearch/data-search/",
          "queryPolicy": "Mission, instrument, product id, bundle, and citation required.",
          "uncertaintyMode": "Instrument/product calibration metadata."
        }
      ],
      "missingSourceIds": [],
      "requiredMaterialRecords": [
        "candidate alloy or sheet material identifier",
        "temperature-dependent elastic/plastic property table",
        "vacuum-compatible joining/forming process window",
        "non-destructive evaluation limit and acceptance criterion"
      ],
      "requiredRuntimeArtifacts": [
        "MOOSE thermo-mechanical forming residual record",
        "OpenFOAM or equivalent thermal-control case record",
        "site thermal environment snapshot"
      ],
      "scenarioFit": [
        {
          "scenarioId": "mercury-orbit",
          "scenarioName": "Mercury Orbit-first",
          "processFit": 84,
          "resourceConfidence": 48,
          "thermalBurden": 82,
          "processMaturityRisk": 62,
          "fitScore": 52.76
        },
        {
          "scenarioId": "asteroid-first",
          "scenarioName": "Asteroid Feedstock-first",
          "processFit": 75,
          "resourceConfidence": 45,
          "thermalBurden": 38,
          "processMaturityRisk": 55,
          "fitScore": 59.2
        },
        {
          "scenarioId": "hybrid",
          "scenarioName": "Hybrid Moon -> Asteroid -> Mercury",
          "processFit": 82,
          "resourceConfidence": 68,
          "thermalBurden": 45,
          "processMaturityRisk": 46,
          "fitScore": 67.36
        }
      ],
      "bestScenarioFit": {
        "scenarioId": "hybrid",
        "scenarioName": "Hybrid Moon -> Asteroid -> Mercury",
        "processFit": 82,
        "resourceConfidence": 68,
        "thermalBurden": 45,
        "processMaturityRisk": 46,
        "fitScore": 67.36
      },
      "evidenceScore": 61,
      "promotionGate": {
        "promotionAllowed": false,
        "state": "blocked-for-process-physics-proof",
        "blockers": [
          "No reviewed material property payload has been promoted for this process.",
          "No process-specific Cantera/MOOSE/OpenFOAM/runtime artifact has been promoted.",
          "No site-specific feedstock or equipment degradation record is attached."
        ],
        "allowedUse": "May be used only as a process-planning hypothesis and evidence backlog item."
      },
      "evidenceHash": "sha256-a14b6b292954ec489ecd7b2f9a567632c84586662b226b178a572b77121edc2b"
    },
    {
      "processId": "spf-db",
      "processName": "Superplastic Forming / Diffusion Bonding",
      "maturity": "Established aerospace family; scale uncertain",
      "uncertainty": "Medium-high",
      "evidenceFamily": "aerospace-superplastic-forming-diffusion-bonding",
      "currentUse": "Established terrestrial process family, but off-world scaling remains unvalidated until site-specific thermal/tooling artifacts exist.",
      "flow": [
        "fine-grained alloy",
        "elevated temperature",
        "forming",
        "bonding",
        "integral structure"
      ],
      "parameters": [
        [
          "Temperature regime",
          "Elevated; process-specific"
        ],
        [
          "Core value",
          "Complex near-net aerospace structures"
        ],
        [
          "Main risk",
          "Large die mass and thermal distortion"
        ]
      ],
      "sourceRefs": [
        {
          "sourceId": "nist-codata",
          "title": "2022 CODATA Fundamental Physical Constants",
          "trust": "primary",
          "sourceType": "physical-constants",
          "recordHash": "fnv1a32-333cff52",
          "url": "https://physics.nist.gov/cuu/Constants/Table/allascii.txt",
          "queryPolicy": "Constants release and exact constant identifiers required.",
          "uncertaintyMode": "CODATA uncertainty or exact-SI status."
        },
        {
          "sourceId": "nist-chemistry-webbook",
          "title": "NIST Chemistry WebBook SRD 69",
          "trust": "primary",
          "sourceType": "chemistry-reference-database",
          "recordHash": "fnv1a32-d9ac987b",
          "url": "https://webbook.nist.gov/chemistry/",
          "queryPolicy": "Species identifier, property table, units, citation, and access date required.",
          "uncertaintyMode": "NIST data notes, property method, and cited evaluation caveats."
        },
        {
          "sourceId": "materials-project",
          "title": "Materials Project API",
          "trust": "primary",
          "sourceType": "materials-property-api",
          "recordHash": "fnv1a32-c46b2daa",
          "url": "https://docs.materialsproject.org/downloading-data/using-the-api",
          "queryPolicy": "mp-id, fields, API version/client, method metadata, and retrieval hash required.",
          "uncertaintyMode": "DFT/method limitations, provenance, and contributed-data caveats."
        },
        {
          "sourceId": "moose-framework",
          "title": "MOOSE Framework",
          "trust": "primary",
          "sourceType": "multiphysics-framework",
          "recordHash": "fnv1a32-a9482599",
          "url": "https://mooseframework.inl.gov/",
          "queryPolicy": "Input file, application/version, mesh hash, material data, and output hash required.",
          "uncertaintyMode": "Discretization, mesh convergence, solver residuals, and material uncertainty."
        },
        {
          "sourceId": "openfoam",
          "title": "OpenFOAM",
          "trust": "open-source",
          "sourceType": "cfd-toolkit",
          "recordHash": "fnv1a32-124056ab",
          "url": "https://www.openfoam.com/",
          "queryPolicy": "Case directory hash, solver/version, mesh, boundary conditions, and result hash required.",
          "uncertaintyMode": "Mesh convergence, turbulence model, chemistry model, and boundary-condition uncertainty."
        }
      ],
      "missingSourceIds": [],
      "requiredMaterialRecords": [
        "alloy and grain-size condition",
        "forming temperature and strain-rate window",
        "diffusion-bonding pressure/time/temperature window",
        "die/tooling mass and thermal distortion model"
      ],
      "requiredRuntimeArtifacts": [
        "thermal cycle energy balance",
        "forming/diffusion-bonding process model",
        "tooling mass sensitivity run"
      ],
      "scenarioFit": [
        {
          "scenarioId": "moon-first",
          "scenarioName": "Moon-first Bootstrap",
          "processFit": 70,
          "resourceConfidence": 74,
          "thermalBurden": 48,
          "processMaturityRisk": 38,
          "fitScore": 65.52
        },
        {
          "scenarioId": "hybrid",
          "scenarioName": "Hybrid Moon -> Asteroid -> Mercury",
          "processFit": 82,
          "resourceConfidence": 68,
          "thermalBurden": 45,
          "processMaturityRisk": 46,
          "fitScore": 67.36
        }
      ],
      "bestScenarioFit": {
        "scenarioId": "hybrid",
        "scenarioName": "Hybrid Moon -> Asteroid -> Mercury",
        "processFit": 82,
        "resourceConfidence": 68,
        "thermalBurden": 45,
        "processMaturityRisk": 46,
        "fitScore": 67.36
      },
      "evidenceScore": 58,
      "promotionGate": {
        "promotionAllowed": false,
        "state": "blocked-for-process-physics-proof",
        "blockers": [
          "No reviewed material property payload has been promoted for this process.",
          "No process-specific Cantera/MOOSE/OpenFOAM/runtime artifact has been promoted.",
          "No site-specific feedstock or equipment degradation record is attached."
        ],
        "allowedUse": "May be used only as a process-planning hypothesis and evidence backlog item."
      },
      "evidenceHash": "sha256-0ada2a49ecad46d6eeab5a8d540299d3dfeec43b6f3b045458b28300396ddb4a"
    },
    {
      "processId": "oxygen-isru",
      "processName": "Oxygen Extraction / ISRU",
      "maturity": "Active research and demo lane",
      "uncertainty": "Medium",
      "evidenceFamily": "oxygen-and-basic-feedstock-processing",
      "currentUse": "May guide source review and process planning only; throughput, reliability, and product economics are not promoted.",
      "flow": [
        "regolith/CO2/water",
        "processing",
        "separation",
        "storage",
        "propellant/life support"
      ],
      "parameters": [
        [
          "Core value",
          "Reduces Earth-launched mass"
        ],
        [
          "Main risk",
          "Throughput and reliability at industrial scale"
        ]
      ],
      "sourceRefs": [
        {
          "sourceId": "nist-chemistry-webbook",
          "title": "NIST Chemistry WebBook SRD 69",
          "trust": "primary",
          "sourceType": "chemistry-reference-database",
          "recordHash": "fnv1a32-d9ac987b",
          "url": "https://webbook.nist.gov/chemistry/",
          "queryPolicy": "Species identifier, property table, units, citation, and access date required.",
          "uncertaintyMode": "NIST data notes, property method, and cited evaluation caveats."
        },
        {
          "sourceId": "materials-project",
          "title": "Materials Project API",
          "trust": "primary",
          "sourceType": "materials-property-api",
          "recordHash": "fnv1a32-c46b2daa",
          "url": "https://docs.materialsproject.org/downloading-data/using-the-api",
          "queryPolicy": "mp-id, fields, API version/client, method metadata, and retrieval hash required.",
          "uncertaintyMode": "DFT/method limitations, provenance, and contributed-data caveats."
        },
        {
          "sourceId": "cantera",
          "title": "Cantera",
          "trust": "open-source",
          "sourceType": "chemistry-transport-toolkit",
          "recordHash": "fnv1a32-883bdb34",
          "url": "https://cantera.org/",
          "queryPolicy": "Mechanism file, tool version, inputs, outputs, and mechanism hash required.",
          "uncertaintyMode": "Mechanism validity range and solver tolerance."
        },
        {
          "sourceId": "moose-framework",
          "title": "MOOSE Framework",
          "trust": "primary",
          "sourceType": "multiphysics-framework",
          "recordHash": "fnv1a32-a9482599",
          "url": "https://mooseframework.inl.gov/",
          "queryPolicy": "Input file, application/version, mesh hash, material data, and output hash required.",
          "uncertaintyMode": "Discretization, mesh convergence, solver residuals, and material uncertainty."
        },
        {
          "sourceId": "pds",
          "title": "Planetary Data System",
          "trust": "primary",
          "sourceType": "mission-data-archive",
          "recordHash": "fnv1a32-7c477cc2",
          "url": "https://pds.nasa.gov/datasearch/data-search/",
          "queryPolicy": "Mission, instrument, product id, bundle, and citation required.",
          "uncertaintyMode": "Instrument/product calibration metadata."
        }
      ],
      "missingSourceIds": [],
      "requiredMaterialRecords": [
        "feedstock composition with mission/archive citation",
        "reaction pathway and species mechanism",
        "energy-per-kg oxygen or product output",
        "waste/slag stream and equipment degradation assumption"
      ],
      "requiredRuntimeArtifacts": [
        "Cantera chemistry/thermodynamics run",
        "thermal reactor or multiphysics energy-balance run",
        "source-backed site feedstock record"
      ],
      "scenarioFit": [
        {
          "scenarioId": "moon-first",
          "scenarioName": "Moon-first Bootstrap",
          "processFit": 70,
          "resourceConfidence": 74,
          "thermalBurden": 48,
          "processMaturityRisk": 38,
          "fitScore": 65.52
        },
        {
          "scenarioId": "mars-first",
          "scenarioName": "Mars-first Conventional Expansion",
          "processFit": 46,
          "resourceConfidence": 65,
          "thermalBurden": 56,
          "processMaturityRisk": 44,
          "fitScore": 51.98
        },
        {
          "scenarioId": "asteroid-first",
          "scenarioName": "Asteroid Feedstock-first",
          "processFit": 75,
          "resourceConfidence": 45,
          "thermalBurden": 38,
          "processMaturityRisk": 55,
          "fitScore": 59.2
        },
        {
          "scenarioId": "hybrid",
          "scenarioName": "Hybrid Moon -> Asteroid -> Mercury",
          "processFit": 82,
          "resourceConfidence": 68,
          "thermalBurden": 45,
          "processMaturityRisk": 46,
          "fitScore": 67.36
        }
      ],
      "bestScenarioFit": {
        "scenarioId": "hybrid",
        "scenarioName": "Hybrid Moon -> Asteroid -> Mercury",
        "processFit": 82,
        "resourceConfidence": 68,
        "thermalBurden": 45,
        "processMaturityRisk": 46,
        "fitScore": 67.36
      },
      "evidenceScore": 64,
      "promotionGate": {
        "promotionAllowed": false,
        "state": "blocked-for-process-physics-proof",
        "blockers": [
          "No reviewed material property payload has been promoted for this process.",
          "No process-specific Cantera/MOOSE/OpenFOAM/runtime artifact has been promoted.",
          "No site-specific feedstock or equipment degradation record is attached."
        ],
        "allowedUse": "May be used only as a process-planning hypothesis and evidence backlog item."
      },
      "evidenceHash": "sha256-e9949f8d6bbce043db6101b136415b59f623e26c4b01d10bf685ba43934313ce"
    }
  ],
  "ledgerHash": "sha256-860c27709b9c2e64ffb883271d74cf5b6e44d14c8c8d2c22404f2adda2914f80"
}
;
